module.exports = __webpack_public_path__ + "static/media/written.f3010851.svg";